import { semantic } from '@lexody/design-tokens';

/** Icon colors for morphism form fields — maps to color-tokens.html semantic roles. */
export const MORPHISM_ICON_COLORS = {
  primary: semantic.primary.text.label,
  premium: semantic.premium.text.label,
  error: semantic.error.text.label,
  success: semantic.success.text.label,
};

export function iconColorForTone(tone) {
  switch (tone) {
    case 'pink':
      return MORPHISM_ICON_COLORS.error;
    case 'green':
      return MORPHISM_ICON_COLORS.success;
    case 'violet':
      return MORPHISM_ICON_COLORS.premium;
    case 'blue':
    case 'grey':
    default:
      return MORPHISM_ICON_COLORS.primary;
  }
}
